import { render } from "./ServiceLocationRow.vue?vue&type=template&id=35e0d48a"
import script from "./ServiceLocationRow.ts?vue&type=script&lang=js&external"
export * from "./ServiceLocationRow.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__